export function getStageNameError(existingStages, name) {
  return existingStages.map((stage) => stage.name).indexOf(name) > -1
    ? "Name already exists"
    : null
}
